var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyBrought(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95458 6.23013L4.1375 5.31138L5.42375 2.70825H14.0702L15.3667 5.31138L13.5496 6.21992L12.8146 4.74992H6.68958L5.95458 6.23013ZM16.4896 8.83325H11.8958L11.0792 5.77075H8.425L7.61854 8.83325H2.99417L1.6875 11.4364L3.51479 12.3449L4.23958 10.8749H15.2442L15.9792 12.3551L17.8065 11.4466L16.4896 8.83325ZM15.6423 23.1249H13.5292L13.2842 22.2062L9.75208 16.8978L6.20979 22.2062L5.975 23.1249H3.86188L6.79167 11.8958H8.92521L8.55771 13.2739L9.75208 15.0603L10.9363 13.2739L10.579 11.8958H12.6921L15.6423 23.1249ZM9.13958 15.9791L8.22083 14.601L7.01625 19.1743L9.13958 15.9791ZM12.4879 19.1641L11.2833 14.5908L10.3646 15.9791L12.4879 19.1641ZM24.1458 16.9999L20.0625 12.9166V15.9791H15.9792V18.0208H20.0625V21.0833L24.1458 16.9999Z",
    fill: "#2B8D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyBrought);
export default __webpack_public_path__ + "static/media/energy_brought.35702a6723e01adb0a1c39f5084beb49.svg";
export { ForwardRef as ReactComponent };